<div class="header" [ngClass]="{'header-hide': !(isVisible$ | async)}" id="spacex-header" *ngIf="{
  navBarExpanded: navBarExpanded$ | async,
  vehiclesMenuOpen: vehiclesMenuOpen$ | async,
  humanSpaceflightMenuOpen: humanSpaceflightMenuOpen$ | async,
  xAIMenuOpen: xAIMenuOpen$ | async,
  shopMenuOpen: shopMenuOpen$ | async,
  companyMenuOpen: companyMenuOpen$ | async,
  anyMenuOpen: anyMenuOpen$ | async } as state">
  <div class="header-shadow"></div>
  <div class="menu-backdrop" [class.open]="state.anyMenuOpen && !isMobile"></div>
  <nav [ngClass]="{ 'black-overlay': state.navBarExpanded && isMobile }">

    <div class="top-bar">
      <div class="spacex-logo">
        <a routerLink="/">
          <spx-logo-svg></spx-logo-svg>
        </a>
      </div>

      <div (click)="toggleNavBar()" class="header-button" aria-label="Open and close navigation menu" role="button">
        <close-svg *ngIf="state.navBarExpanded"></close-svg>
        <menu-svg *ngIf="!state.navBarExpanded"></menu-svg>
      </div>
    </div>

    <ng-container *ngIf="state.navBarExpanded || !isMobile">
      <div class="nav-links">

        <!-- Vehicles -->
        <div (mouseleave)="closeVehiclesMenu()">
          <div (mouseenter)="openVehiclesMenu()" (click)="toggleVehiclesMenu()" aria-label="Open SpaceX vehicles menu"
            id="vehicles-menu-header">
            <div class="menu-header sub-menu-header">
              <span [class.open]="state.vehiclesMenuOpen">Vehicles</span>
              <span class="down-arrow-icon">
                <down-arrow-svg *ngIf="state.vehiclesMenuOpen || isMobile"></down-arrow-svg>
              </span>
            </div>
          </div>

          <ul aria-label="SpaceX vehicles menu" class="sub-menu" [ngClass]="{'open': state.vehiclesMenuOpen}"
            id="vehicles-menu">
            <li><a routerLink="/vehicles/starship" aria-label="Go to Starship page">Starship</a></li>
            <li><a routerLink="/vehicles/dragon" aria-label="Go to Dragon page">Dragon</a></li>
            <li><a routerLink="/vehicles/falcon-9" aria-label="Go to Falcon 9 page">Falcon 9</a></li>
            <li><a routerLink="/vehicles/falcon-heavy" aria-label="Go to Falcon Heavy page">Falcon Heavy</a></li>
          </ul>
        </div>

        <!-- Human Spaceflight -->
        <div (mouseleave)="closeHumanSpaceflightMenu()">
          <div (mouseenter)="openHumanSpaceflightMenu()" (click)="toggleHumanSpaceflightMenu()"
            aria-label="Open Human Spaceflight menu" id="human-spaceflight-menu-header">
            <div class="menu-header sub-menu-header">
              <span [class.open]="state.humanSpaceflightMenuOpen">Human Spaceflight</span>
              <span class="down-arrow-icon">
                <down-arrow-svg *ngIf="state.humanSpaceflightMenuOpen || isMobile"></down-arrow-svg>
              </span>
            </div>
          </div>

          <ul aria-label="SpaceX Human Spaceflight menu" class="sub-menu"
            [ngClass]="{'open': state.humanSpaceflightMenuOpen}" id="human-spaceflight-menu">
            <li><a routerLink="/humanspaceflight/overview" aria-label="Go to Overview page">Overview</a></li>
            <li><a routerLink="/humanspaceflight/iss" aria-label="Go to Space Station page">Space Station</a></li>
            <li><a routerLink="/humanspaceflight/earth" aria-label="Go to Earch Orbit page">Earth Orbit</a></li>
            <li><a routerLink="/humanspaceflight/moon" aria-label="Go to The Moon page">The Moon</a></li>
            <li><a routerLink="/humanspaceflight/mars" aria-label="Go to Mars & Beyond page">Mars & Beyond</a></li>
          </ul>
        </div>

        <!-- Starlink -->
        <div class="menu-header">
          <a href="https://starlink.com" target="_blank" rel="noopener noreferrer"
            aria-label="Starlink website">Starlink</a>
        </div>

        <!-- Starshield -->
        <div class="menu-header">
          <a routerLink="/starshield">Starshield</a>
        </div>

        <!-- xAI -->
        <div (mouseleave)="closexAIMenu()">
          <div (mouseenter)="openxAIMenu()" (click)="togglexAIMenu()" aria-label="Navigate to SpaceXAI menu"
            id="xai-menu-header">
            <div class="menu-header sub-menu-header">
              <span class="preformat" [class.open]="state.xAIMenuOpen">SPACEXAI</span>
              <span class="down-arrow-icon">
                <down-arrow-svg *ngIf="state.xAIMenuOpen || isMobile"></down-arrow-svg>
              </span>
            </div>
          </div>

          <ul aria-label="SpaceXAI menu" class="sub-menu" [ngClass]="{'open': state.xAIMenuOpen}" id="xai-menu">
            <li><a href="/spacexai/starmind" aria-label="Go to AI Satellite page">STARMIND</a></li>
            <li><a href="https://x.ai" aria-label="Go to Grok's page" target="_blank">GROK</a></li>
            <li><a href="https://grokipedia.com" aria-label="Go to the Grokipedia page" target="_blank">GROKIPEDIA</a>
            </li>
            <li><a href="https://x.com" aria-label="Go to X" target="_blank">𝕏</a></li>
          </ul>
        </div>

        <!-- Terafab -->
        <div class="menu-header">
          <a href="https://terafab.ai" target="_blank" rel="noopener noreferrer"
            aria-label="Open the terafab website">Terafab</a>
        </div>

        <!-- Company -->
        <div (mouseleave)="closeCompanyMenu()">
          <div (mouseenter)="openCompanyMenu()" (click)="toggleCompanyMenu()" aria-label="Open SpaceX launches menu"
            id="company-menu-header">
            <div class="menu-header sub-menu-header">
              <span [class.open]="state.companyMenuOpen">Company</span>
              <span class="down-arrow-icon">
                <down-arrow-svg *ngIf="state.companyMenuOpen || isMobile"></down-arrow-svg>
              </span>
            </div>
          </div>

          <ul aria-label="SpaceX company menu" class="sub-menu" [ngClass]="{'open': state.companyMenuOpen}"
            id="company-menu">
            <li><a routerLink="/mission" aria-label="Go to mission page">Mission</a></li>
            <li><a routerLink="/careers" aria-label="Go to careers page">Careers</a></li>
            <li><a routerLink="/sites" aria-label="Go to sites page">Sites</a></li>
            <li><a routerLink="/updates" aria-label="Go to updates page">Updates</a></li>
            <li><a *ngIf="isContentHubEnabled()" routerLink="/content" aria-label="Go to content page">Content</a></li>
            <li><a href="https://ir.spacex.com" target="_blank" rel="noopener noreferrer" aria-label="Go to investor relations page">Investors</a></li>
          </ul>
        </div>

        <!-- Shop -->
        <div (mouseleave)="closeShopMenu()">
          <div (mouseenter)="openShopMenu()" (click)="toggleShopMenu()" aria-label="Navigate to the Shop menu"
            id="shop-menu-header">
            <div class="menu-header sub-menu-header">
              <span [class.open]="state.shopMenuOpen">Shop</span>
              <span class="down-arrow-icon">
                <down-arrow-svg *ngIf="state.shopMenuOpen || isMobile"></down-arrow-svg>
              </span>
            </div>
          </div>

          <ul aria-label="Shop menu" class="sub-menu" [ngClass]="{'open': state.shopMenuOpen}" id="shop-menu">
            <li><a href="https://shop.spacex.com" aria-label="Go to the SpaceX Shop" target="_blank">SpaceX</a></li>
            <li><a href="https://shop.x.com" aria-label="Go to the xAI Shop" target="_blank" class="">SPACEXAI</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Upcoming Launches Widget -->
      <upcoming-launch-widget class="pull-right"></upcoming-launch-widget>
    </ng-container>
  </nav>
</div>